import React, { FC } from 'react'
import { MarketingBottomTemporaryDrawer } from '../modal'
import { CtaHtmlInputRest } from '../cta/searchbar/cta-html-input-rest'
import { CtaInputRest } from '../cta/searchbar/cta-input-rest'
import { WCAGSelectInput } from '../general/select/select-input'
import { RunnerSelect } from '../general/runner-select'
import { GrInfo } from 'react-icons/gr'
import { QueryViewProps } from './query'

export const QueryView: FC<QueryViewProps> = ({
  queryStyle,
  onStandardChange,
  onRunnerChange,
  standard,
  runners,
  queryModalVisible,
  t,
}) => {
  return (
    <div className={queryStyle}>
      <div className='py-4 h-full'>
        <div className='flex flex-col place-items-center place-content-center space-y-6'>
          <div className='flex place-items-center gap-2 flex-wrap'>
            <RunnerSelect cb={onRunnerChange} />
            <WCAGSelectInput
              onStandardChange={onStandardChange}
              standard={standard}
              className='rounded border-gray-700 dark:border-gray-300'
              spacing
            />
          </div>
          <CtaInputRest standard={standard} runners={runners} />
          <p>{`${t('or')} ${t('html')}`}</p>
          <CtaHtmlInputRest
            standard={standard}
            queryModalVisible={queryModalVisible}
            runners={runners}
          />
          <div className='flex border rounded gap-x-4 py-2 px-4 place-items-center text-sm dark:border-gray-600'>
            <GrInfo className='grIcon text-gray-600 dark:text-gray-300' />
            {t('dashboard:html-note')}
          </div>
        </div>
        <MarketingBottomTemporaryDrawer authenticated />
      </div>
    </div>
  )
}
